<template>
  <div>
    <el-table style="width: 100%" :data="tableData" border>
      <el-table-column prop="paramName" label="参数" min-width="120" key="pn">
        <template slot-scope="scope">
          {{scope.row.paramName}}
          <el-tooltip effect="dark" :content="scope.row.paramDesc" placement="top" popper-class="prod__record" v-if="scope.row.paramDesc">
            <i style="margin-left: 2px;color: #f8ab01;font-size: 10px;cursor: pointer;" class="el-icon-info"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-for="(column, index) in columns" :key="index" :label="column.columnName" min-width="120">
        <template slot="header" slot-scope="scope">
          {{column.columnName}}
          <el-tooltip effect="dark" :content="column.columnDesc" placement="top" popper-class="prod__record" v-if="column.columnDesc">
            <i style="margin-left: 2px;color: #f8ab01;font-size: 10px;cursor: pointer;" class="el-icon-info"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    previewMultiLists: {
      type: Array,
      default: () => [] // 默认值为空数组
    },
    previewColumns: {
      type: Array,
      default: () => [] // 默认值为空数组
    }
  },
  watch: {
    previewMultiLists: {
      handler(newVal) {
        console.log("🚀 ~ handler ~ newVal:", newVal)
        this.tableData = [...newVal]
      },
      deep: true,
      immediate: true
    },
    previewColumns: {
      handler(newVal) {
        console.log("🚀 ~ handler ~ newVal222:", newVal)
        this.columns = [...newVal]
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      tableData: [],
      columns: []
    }
  }
}
</script>